var p={NONE:"none",S:"0 1px 3px 1px rgba(0, 0, 0, 0.2)",M:"0 1px 6px 2px rgba(0, 0, 0, 0.2)",L:"0 2px 8px 3px rgba(0, 0, 0, 0.2)"};export{p as default};
